import Api from "../userApiServices/axiosInstance";

const GetPaginatedQueueMessages = (params) => {
  const url = `/grpc/queue.QueueService/GetPaginatedQueueMessages`;
  return Api.post(url, params);
};

const fetchPaginatedArchiveMessage = (params) => {
  const url = `/grpc/conversation.ConversationService/GetPaginatedArchivedMessages`;
  return Api.post(url, params);
};

export const SocketApiService = {
    GetPaginatedQueueMessages,
    fetchPaginatedArchiveMessage
};
